export type E1LogoProps = {
  width?: number;
};
export const E1Logo = ({ width = 22 }: E1LogoProps) => {
  const aspectRatio = 22 / 24;
  return (
    <svg
      width={width}
      height={aspectRatio * width}
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2_123)">
        <path
          d="M21 1.0502V21.2037C20.9845 21.2086 20.9698 21.2152 20.9535 21.2193C18.862 21.7456 16.7705 22.2711 14.679 22.7965C14.4336 22.8583 14.1874 22.9176 13.9256 22.9827V21.2004H1.02118V1.04443C1.075 1.04443 1.12066 1.04443 1.1655 1.04443C7.73432 1.04443 14.304 1.04443 20.8728 1.04443C20.9152 1.04443 20.9576 1.04773 20.9992 1.0502H21ZM13.9281 21.1987C13.9688 21.1905 14.0006 21.1847 14.0316 21.1773C15.7342 20.7499 17.4367 20.3208 19.1401 19.8958C19.22 19.876 19.2395 19.8423 19.2395 19.7624C19.2379 14.1537 19.2379 8.54496 19.2379 2.93624V2.83412H2.78406V19.4297H13.9281V21.1996V21.1987Z"
          fill="#141B4D"
        />
        <path
          d="M11.7795 16.5183H5.46509V5.73486H11.7803V8.1233H11.6417C10.4153 8.1233 9.189 8.1233 7.96264 8.1233C7.8773 8.1233 7.83435 8.16586 7.83381 8.25096C7.83381 8.77395 7.83626 9.29693 7.83136 9.81992C7.83136 9.90887 7.85746 9.92946 7.94226 9.92946C9.17187 9.92699 10.4015 9.92781 11.6311 9.92781C11.6768 9.92781 11.7216 9.92781 11.7771 9.92781V12.3179H7.84278V14.1208H11.7787V16.5191L11.7795 16.5183Z"
          fill="#141B4D"
        />
        <path
          d="M14.1759 8.12324H12.8452C12.8721 8.05653 12.8933 8.00299 12.9153 7.95028C13.2219 7.23622 13.5293 6.52298 13.8343 5.8081C13.8579 5.75292 13.8816 5.72656 13.9468 5.72656C14.7883 5.72903 15.629 5.72821 16.4705 5.72821C16.4933 5.72821 16.5153 5.7315 16.5447 5.73315V16.5182H14.1768V8.12324H14.1759Z"
          fill="#141B4D"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_123">
          <rect width="20" height="22" fill="white" transform="translate(1 1)" />
        </clipPath>
      </defs>
    </svg>
  );
};

E1Logo.displayName = 'E1Logo';
